import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { WorkshopModel } from '../models/workshop.model';
import { environment } from '../../../../environments/environment';
import { HeldWorkshopModel } from '../../held-workshop/models/held-workshop.model';
import { WorkshopRegistrationRequestModel } from '../../../shared/models/workshop-registration-request.model';

@Injectable({
  providedIn: 'root',
})
export class WorkshopService {
  apiUrl: string = environment.baseApi + 'trainings/workshops/';

  constructor(private http: HttpClient) {}

  getWorkshopsOnRegistering() {
    return this.http.get<WorkshopModel[]>(this.apiUrl + 'on-registering/');
  }

  getWorkshop(id: number) {
    return this.http.get<WorkshopModel>(this.apiUrl + id + '/');
  }

  registerOnWorkshop(
    id: number,
    workshopRegistrationRequestModel: WorkshopRegistrationRequestModel,
  ) {
    return this.http.post(
      this.apiUrl + id + '/register/',
      workshopRegistrationRequestModel,
    );
  }

  getHeldWorkshopList() {
    return this.http.get<HeldWorkshopModel[]>(this.apiUrl + 'held/');
  }

  searchHeldWorkshops(searchParams): Observable<HeldWorkshopModel[]> {
    let params = new HttpParams();
    Object.keys(searchParams).forEach((key) => {
      const value = (searchParams as any)[key];
      if (value) {
        params = params.append(key, value);
      }
    });
    return this.http.get<HeldWorkshopModel[]>(this.apiUrl + 'held/', {
      params: params,
    });
  }

  preRegisterWorkshop(
    id: number,
    workshopRegistrationRequestModel: WorkshopRegistrationRequestModel,
  ) {
    return this.http.post(
      this.apiUrl + id + '/pre-register/',
      workshopRegistrationRequestModel,
    );
  }

  getWorkShopsGroupedByRegisteringMonth(): Observable<{ [key: number]: any }> {
    return this.http.get<{ [key: number]: any }>(
      this.apiUrl + 'on-registering/by-month-name/',
    );
  }
}
